import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { JustifiedView } from '@commoncore/utils/JustifiedViewUtil';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { LocalStorageProps } from '../enums/localStorageProps';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';

export class FoldersViewImplementation {
    // public nameSort:boolean  = true;
    public router: any;
    public http: any;
    public route:any;
    public universalService:any;
    public globalService:any;
    public allFilespreviousLink = "";
    public sortOrder:any;
    public flag:boolean = false;
    public rootFolderCheck:boolean = false;
    public docheignt:number=0;
    public toppos:number=0; 
    public customMetadata:any;
    public JsView:JustifiedView;
    public customSort:any;
    public sortByDateArray:any = [];
    public sortByNameArray:any = [];
    public multiSelect:any;
    public listService:any;
    public contextMenuService: any;
    folderService: any;
    localStorageSvc:any;
    public folderShownCount: number=0;
    shareAccessService:any;
    sessionStorageService:any;
    static singleInstance:FoldersViewImplementation;
    constructor(globalService) {
      this.globalService=globalService;
      this.localStorageSvc = this.globalService.getLocalStorageSvcRef()
      this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    }

    public setHandler(globalService){
    this.universalService=globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.http=globalService.getHttpClientRef();
    this.route = globalService.getActivatedRoute();
    this.listService = globalService.getListServiceRef();
    this.JsView = new JustifiedView(this.universalService);
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.folderService = globalService.getFolderServiceRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    }

    public static getInstance(globalService):FoldersViewImplementation{
      if(this.singleInstance == null){
        this.singleInstance = new FoldersViewImplementation(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }
    

    

    


    async openFolderContent(folderObjectKey, folderObjectName,folderObject) { 
      
      this.universalService.showMobOptionMenu = false;
      this.universalService.disableModalBackdrop();

      if (this.universalService.openFolderContent) {
        this.universalService.showMobFileInfoPanel = false;
        this.listService.cellclick = false;
        this.universalService.isServerError = false;
        this.universalService.selectedNodes = [];
        if (folderObjectKey == "1") {
          this.universalService.openFolderContent = false;// this.listService.openFolderContent = false;
          if (this.universalService.activeRepo == "main") {
            if(this.router.url.includes("shared/sharedbyme")){
              this.router.navigate(['shared/sharedbyme'])
            }else if (this.router.url.includes("shared/sharedwithme")){
              if(this.universalService.userLoggedIn == true) {
                this.shareAccessService.singleObjectShared = "";
                this.sessionStorageService.setSingleSharedObject(this.shareAccessService.singleObjectShared,true)
              }
              this.router.navigate(['shared/sharedwithme'])
            }else if (this.router.url.includes("teamfolders")){
              this.router.navigate(['teamfolders']);
            }else if (this.router.url.includes("jpai")){
              this.router.navigate(['jpai']);
              this.sessionStorageService.removeSessionProperty(SessionStorageProps.CURRENT_FOLDER_KEY);
            }else{
              var searchKey = this.localStorageSvc.getSearchKey(LocalStorageProps.SEARCH_KEY);
              if(searchKey != ""){
                if(searchKey["searchType"] == "global"){
                  this.router.navigate(['/search'],{ queryParams: { q: searchKey["keyword"]}});
                }else{
                  this.router.navigate(['/search', JSON.parse(decodeURIComponent(btoa(searchKey)))["keyword"]]);
                }
              }else{
                this.localStorageSvc.removeLocalProperty(LocalStorageProps.SEARCH_KEY)
                if(this.universalService.currentTab == "PrivateFolder"){
                  this.router.navigate(['/privatefolder'])
                }else{
                  AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
                  this.router.navigate(['allfiles', USER_DETAILS["USER_DETAILS"]["rootFolderKey"]])
                }
              }
            } 
          }else{
            if (this.universalService.firstTimeHit) {
              this.universalService.firstTimeHit = false;
            }
            // this.router.navigate(['/viewfiles'],{queryParams: {s:this.shareAccessService.shareKey}})
            AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
          }
          if(this.universalService.currentTab == "PrivateFolder"){
            this.sessionStorageService.setCurrentPrivateFolderKey(null, true);
          }else{
            this.sessionStorageService.setCurrentFolderKey(null, true);
            this.localStorageSvc.setSharedFolder(null, true);
          }
          this.universalService.mobileSelectedObj = [];
        } else {
          if(this.universalService.currentTab == "PrivateFolder"){
            this.sessionStorageService.setCurrentPrivateFolderKey(folderObjectKey, true);
          }else{
            this.sessionStorageService.setCurrentFolderKey(folderObjectKey, true);
            this.localStorageSvc.setSharedFolder(folderObject, true);
          }
          this.universalService.openFolderContent = true;
        }
        this.folderService.clickedFolderName = folderObjectName;

        this.folderService.manageBreadCrumbs(folderObjectKey, folderObjectName, folderObject);
        this.universalService.foldersArray = [];
        jQuery("#customContextMenu").hide();
        return 'open folder';
      } else {
        this.universalService.showMobFileInfoPanel = false;

        this.universalService.openFolderContent = true;
      }
    }
}